import { createSlice } from "@reduxjs/toolkit";

interface InvoicesStateType {
    InvoicesError?: string | object | null | undefined | unknown,
    message: any,
    loading: any,
    invoices?: any
}
export const initialState: InvoicesStateType = {
    InvoicesError: null,
    message: null,
    loading: false,
    invoices: null,
};

const InvoicesSlice = createSlice({
    name: "invoices",
    initialState,
    reducers: {
        setInvoicesSuccessful(state, action) {
            state.invoices = action.payload
        },
        setInvoicesFailed(state, action) {
            state.invoices = action.payload
        },
        clearInvoices(state) {
            state.invoices = null; // Reset `agency` state
        },
    },
});

export const {
    setInvoicesSuccessful,
    setInvoicesFailed,
    clearInvoices 
} = InvoicesSlice.actions

export default InvoicesSlice.reducer;